document.addEventListener('click', function (e) {
    var btn = e.target.closest('.accordion-header');
    if (!btn) return;

    var item = btn.closest('.accordion-item');
    if (!item) return;

    var content = item.querySelector('.accordion-content');
    if (!content) return;

    var group = item.closest('.logistics-group');
    if (!group) return;

    var isOpen = item.classList.contains('open');

    group.querySelectorAll('.accordion-item').forEach(function (i) {
        i.classList.remove('open');
        var c = i.querySelector('.accordion-content');
        if (c) c.style.maxHeight = null;
    });

    if (!isOpen) {
        item.classList.add('open');
        content.style.maxHeight = content.scrollHeight + 'px';
    }
});

/* ============================================================
   Read More for the editorial intro (dynamic metaobject text).
   A few lines of the text show as a preview; the button then
   expands/collapses the rest smoothly on both mobile and desktop.
   ============================================================ */
(function () {
    function initEssentialReadMore(scope) {
        var root = scope || document;

        root.querySelectorAll('.eg-read-more-wrapper').forEach(function (wrapper) {
            if (wrapper.dataset.rmInit === 'true') return;

            var content = wrapper.querySelector('.eg-read-more-content');
            // Button lives in the same .editorial-intro block (below the wrapper).
            var container = wrapper.closest('.editorial-intro') || wrapper.parentElement;
            var btn = container ? container.querySelector('.eg-read-more-btn') : null;
            if (!content || !btn) return;

            wrapper.dataset.rmInit = 'true';

            var textSpan = btn.querySelector('.eg-rm-text');
            var moreLabel = textSpan ? textSpan.textContent.trim() : 'Read More';
            var lessLabel = btn.dataset.lessLabel || 'Show Less';
            var EASE = 'max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1)';

            // Collapsed preview height = (preview lines) x (line height), read
            // from the actual rendered styles so it matches the theme's fonts.
            function previewHeight() {
                var lines = parseInt(getComputedStyle(wrapper).getPropertyValue('--eg-preview-lines'), 10) || 3;
                var lh = parseFloat(getComputedStyle(content).lineHeight) || 28;
                return Math.round(lines * lh);
            }

            // Decide whether a toggle is needed and set the collapsed height.
            // Runs on init, on resize, and once web fonts have loaded (which can
            // change the measured height). Applied WITHOUT a transition so it
            // never animates on load/resize — only the click animates.
            function evaluate() {
                if (wrapper.classList.contains('is-expanded')) return;
                wrapper.style.transition = 'none';
                var limit = previewHeight();
                if (content.scrollHeight <= limit + 24) {
                    // Full text fits the preview — show all, drop the button.
                    wrapper.style.maxHeight = 'none';
                    wrapper.classList.add('is-expanded');
                    btn.style.display = 'none';
                } else {
                    btn.style.display = '';
                    wrapper.style.maxHeight = limit + 'px';
                }
                // Force a reflow so the next transition starts from this height.
                void wrapper.offsetHeight;
                wrapper.style.transition = EASE;
            }

            evaluate();
            window.addEventListener('resize', evaluate);
            window.addEventListener('load', evaluate);
            if (document.fonts && document.fonts.ready) {
                document.fonts.ready.then(evaluate);
            }

            btn.addEventListener('click', function (e) {
                e.stopPropagation();
                wrapper.style.transition = EASE;

                if (wrapper.classList.contains('is-expanded')) {
                    // Collapse: pin the current full height, then (next frame)
                    // animate down to the preview height.
                    wrapper.style.maxHeight = content.scrollHeight + 'px';
                    void wrapper.offsetHeight; // flush so 'none' -> px doesn't skip
                    requestAnimationFrame(function () {
                        wrapper.style.maxHeight = previewHeight() + 'px';
                    });
                    wrapper.classList.remove('is-expanded');
                    btn.classList.remove('is-expanded');
                    if (textSpan) textSpan.textContent = moreLabel;
                } else {
                    // Expand: animate to the full height + a buffer so trailing
                    // paragraph margins are never clipped (prevents the end jump).
                    wrapper.style.maxHeight = (content.scrollHeight + 60) + 'px';
                    wrapper.classList.add('is-expanded');
                    btn.classList.add('is-expanded');
                    if (textSpan) textSpan.textContent = lessLabel;

                    // After the transition, release the cap so the text can
                    // reflow freely (e.g. on rotation / resize).
                    setTimeout(function () {
                        if (wrapper.classList.contains('is-expanded')) {
                            wrapper.style.maxHeight = 'none';
                        }
                    }, 450);
                }
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            initEssentialReadMore();
        });
    } else {
        initEssentialReadMore();
    }

    // Re-init when the section is added/edited in the theme editor.
    document.addEventListener('shopify:section:load', function (e) {
        initEssentialReadMore(e.target);
    });
})();